import React, { Component } from "react";
import { connect } from "react-redux";
import { AUSTRALIAN_STATES } from "utils/referenceData";
import "assets/stylesheets/SvgMapSelect.scss";

class SvgMapSelect extends Component {
  render() {
    const { activeState } = this.props;
    return (
      <section id="state-selection">
        <svg
          id="australia-map"
          data-name="australia-map"
          xmlns="http://w3.org/2000/svg"
          viewBox="0 0 189.75 175.41"
        >
          {AUSTRALIAN_STATES.map((state) => (
            <path
              id={state.id}
              key={state.id}
              d={state.path}
              className={"cls-1 " + (activeState === state.id && "selected")}
              transform="translate(-3.62 -18.85)"
              onClick={() => this.props.handleStateChange(state.id)}
            ></path>
          ))}
        </svg>
      </section>
    );
  }
}

const mapStateToProps = (store) => {
  const { activeState } = store.selectStateReducer;
  return {
    activeState: activeState,
  };
};

export default connect(mapStateToProps)(SvgMapSelect);
